module.exports = __webpack_public_path__ + "assets/apolyPille_default.3355f981.png";